import services from "../../services/services";
import Swal from 'sweetalert2';

const state = {
    invoices: [],
}

const mutations = {
    'SET_INVOICES'(state, data) {
        state.invoices = data;
    }
}

const actions = {
    getInvoices: ({commit}, {seasonFrom, seasonTo}) => {
        return services.getInvoices(seasonFrom, seasonTo).then(response => {
            if (response.status === 200) {
                commit('SET_INVOICES', response.data);
            }
            return response;
        });
    },
    addInvoice: ({commit}, payload) => {
        return services.addInvoice(payload).then((response) => {
            if (response.status === 201) {
                commit('SET_INVOICES', response.data);
                return response;
            }
            if (response.responseStatus === 409) {
                Swal.fire({
                    title: 'Outdated informations',
                    confirmButtonText: 'Refresh',
                  }).then((result) => {
                    if (result.isConfirmed) {
                        services.getContractors();
                    }
                  });
            }
        });
    },
    updateInvoice: ({commit}, payload) => {
        services.updateInvoice(payload).then((response) => {
            if (response.status === 200) {
                commit('SET_INVOICES', response.data);
            }
        });
    },
    deleteInvoice: ({commit}, payload) => {
        return services.deleteInvoice(payload).then((response) => {
            if (response.status === 204) {
                commit('SET_INVOICES', response.data);
            }
            
            return response;
        });
    }
}

const getters = {
    invoices: state => {
        return state.invoices;
    },
}

export default {
    state, mutations, actions, getters
}
